import React, { createContext, useContext, useEffect, useState } from 'react';

export const THEMES = [
  {
    id: 'dark',
    label: 'Desk',
    hint: 'Current institutional dark',
  },
  {
    id: 'light',
    label: 'Light',
    hint: 'Daytime high contrast',
  },
  {
    id: 'robinhood',
    label: 'Robinhood',
    hint: 'Legend-style black & green',
  },
];

export const THEME_IDS = THEMES.map((t) => t.id);

export function isDarkTheme(theme) {
  return theme !== 'light';
}

function applyTheme(theme) {
  const root = document.documentElement;
  const resolved = THEME_IDS.includes(theme) ? theme : 'dark';
  root.setAttribute('data-theme', resolved);
  root.classList.toggle('dark', isDarkTheme(resolved));
  root.style.colorScheme = isDarkTheme(resolved) ? 'dark' : 'light';
}

const ThemeContext = createContext(null);

export const ThemeProvider = ({ children }) => {
  const [theme, setThemeState] = useState(() => {
    const saved = localStorage.getItem('lt-theme');
    if (THEME_IDS.includes(saved)) return saved;
    return 'dark';
  });

  useEffect(() => {
    applyTheme(theme);
    localStorage.setItem('lt-theme', theme);
  }, [theme]);

  const setTheme = (next) => {
    if (THEME_IDS.includes(next)) setThemeState(next);
  };

  const toggleTheme = () => {
    setThemeState((prev) => {
      const i = THEME_IDS.indexOf(prev);
      return THEME_IDS[(i + 1) % THEME_IDS.length];
    });
  };

  return (
    <ThemeContext.Provider
      value={{
        theme,
        setTheme,
        toggleTheme,
        isDark: isDarkTheme(theme),
        themes: THEMES,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
